import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
import { checkFilter } from "../../../Common/filterUtils";
import { treatmentService } from "../../../Axios/treatmentService";

export const getTreatment = createAsyncThunk(
    'treatment/getTreatment',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await treatmentService.getTreatment(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitTreatment = createAsyncThunk(
    'treatment/submitTreatment',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('description', data.description);
            formData.append('price', data.price);
            formData.append('gimmick_price', data.gimmick_price);
            formData.append('category_id', data.category_id);
            data.benefits && data.benefits.length > 0 && formData.append('benefits', `"${JSON.stringify(data.benefits).replace(/"/g, '\\"')}"`);
            data.process && data.process.length > 0 && formData.append('process', `"${JSON.stringify(data.process).replace(/"/g, '\\"')}"`);
            if (data.photos && data.photos.length > 0) {
                data.photos.forEach((photo, index) => {
                    formData.append(`photos[${index}]`, photo);
                });
            } else {
                formData.append('photos', []);
            }

            let response;
            if (data.id) {
                response = await treatmentService.updateTreatment(data.id, formData);
            } else {
                response = await treatmentService.createTreatment(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteTreatment = createAsyncThunk(
    'treatment/deleteTreatment',
    async (id, { rejectWithValue }) => {
        try {
            const response = await treatmentService.deleteTreatment(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deletePhotos = createAsyncThunk(
    'treatment/deletePhotos',
    async ({ pivotId }, { rejectWithValue }) => {
        try {
            const response = await treatmentService.deletePhotos(pivotId);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
